<po-page-default
  p-title="{{pageTitle}}">
  @if(showPage){
    <po-container class="po-md-12">
      <po-divider class="po-md-12" p-label="DADOS DO PEDIDO"></po-divider>
      <div class="po-md-12">
        <po-info class="po-md-2"
          p-label="Número"
          [p-value]="dadosCabec.cPedido">
        </po-info>
        <po-info class="po-md-2"
          p-label="Data Emissão"
          [p-value]="dadosCabec.cDataEmissao">
        </po-info>
        <po-info class="po-md-8"
          p-label="Comprador"
          [p-value]="dadosCabec.cNomeComprador">
        </po-info>
        <po-info class="po-md-2"
          p-label="Frete"
          [p-value]="dadosCabec.cTipoFrete">
        </po-info>
        <po-info class="po-md-2"
          p-label="Valor Frete"
          [p-value]="dadosCabec.nValorFrete">
        </po-info>
        <po-info class="po-md-2"
          p-label="Cond. Pgto"
          [p-value]="dadosCabec.cDescCondPag">
        </po-info>
        <po-info class="po-md-6"
          p-label="Transportadora"
          [p-value]="dadosCabec.cTransportadora">
        </po-info>
      </div>
      @if(dadosCabec.lServico){
        <div class="po-md-12">
          <br><p style="font-size: 15px; font-family: sans-serif; margin-left: 8px;">Fica condicionado o pagamento os documentos que forem emitidos até o dia 25 de cada mês, documentos emitidos depois dessa data serão rejeitados.</p>
        </div>
      }

      <po-divider class="po-md-12 po-mt-1" p-label="DADOS DO CLIENTE"></po-divider>
      <div class="po-md-12">
        <po-info class="po-md-6"
          p-label="Razão Social"
          [p-value]="dadosCabec.cCliRazaoSocial"
          p-label-size="3"
          p-orientation="horizontal">
        </po-info>
        <po-info class="po-md-6"
          p-label="CNPJ"
          [p-value]="dadosCabec.cCliCNPJ"
          p-label-size="3"
          p-orientation="horizontal">
        </po-info>
        <po-info class="po-md-6"
          p-label="Endereço"
          [p-value]="dadosCabec.cCliEndereco"
          p-label-size="3"
          p-orientation="horizontal">
        </po-info>
        <po-info class="po-md-6"
          p-label="Bairro"
          [p-value]="dadosCabec.cCliBairro"
          p-label-size="3"
          p-orientation="horizontal">
        </po-info>
        <po-info class="po-md-6"
          p-label="Código/Município"
          [p-value]="dadosCabec.cCliCodMun"
          p-label-size="3"
          p-orientation="horizontal">
        </po-info>
        <po-info class="po-md-6"
          p-label="Estado/Cep"
          [p-value]="dadosCabec.cCliEstado"
          p-label-size="3"
          p-orientation="horizontal">
        </po-info>
        <po-info class="po-md-6"
          p-label="Inscrição Estadual"
          [p-value]="dadosCabec.cCliInscrEst"
          p-label-size="3"
          p-orientation="horizontal">
        </po-info>
        <po-info class="po-md-6"
          p-label="Inscrição Municipal"
          [p-value]="dadosCabec.cCliInscrMun"
          p-label-size="3"
          p-orientation="horizontal">
        </po-info>
        <po-info class="po-md-6"
          p-label="Telefone"
          [p-value]="dadosCabec.cCliTelefone"
          p-label-size="3"
          p-orientation="horizontal">
        </po-info>
        <po-info class="po-md-6"
          p-label="Fax"
          [p-value]="dadosCabec.cCliFax"
          p-label-size="3"
          p-orientation="horizontal">
        </po-info>
      </div>

      <po-divider class="po-md-12 po-mt-1" p-label="DADOS DO FORNECEDOR"></po-divider>
      <div class="po-md-12">
        <po-info class="po-md-6"
          p-label="Razão Social"
          [p-value]="dadosCabec.cForRazaoSocial"
          p-label-size="3"
          p-orientation="horizontal">
        </po-info>
        <po-info class="po-md-6"
          p-label="CNPJ"
          [p-value]="dadosCabec.cForCNPJ"
          p-label-size="3"
          p-orientation="horizontal">
        </po-info>
        <po-info class="po-md-6"
          p-label="Endereço"
          [p-value]="dadosCabec.cForEndereco"
          p-label-size="3"
          p-orientation="horizontal">
        </po-info>
        <po-info class="po-md-6"
          p-label="Bairro"
          [p-value]="dadosCabec.cForBairro"
          p-label-size="3"
          p-orientation="horizontal">
        </po-info>
        <po-info class="po-md-6"
          p-label="Código/Município"
          [p-value]="dadosCabec.cForCodMun"
          p-label-size="3"
          p-orientation="horizontal">
        </po-info>
        <po-info class="po-md-6"
          p-label="Estado/Cep"
          [p-value]="dadosCabec.cForEstado"
          p-label-size="3"
          p-orientation="horizontal">
        </po-info>
        <po-info class="po-md-6"
          p-label="Inscrição Estadual"
          [p-value]="dadosCabec.cForInscrEst"
          p-label-size="3"
          p-orientation="horizontal">
        </po-info>
        <po-info class="po-md-6"
          p-label="Inscrição Municipal"
          [p-value]="dadosCabec.cForInscrMun"
          p-label-size="3"
          p-orientation="horizontal">
        </po-info>
        <po-info class="po-md-6"
          p-label="Telefone"
          [p-value]="dadosCabec.cForTelefone"
          p-label-size="3"
          p-orientation="horizontal">
        </po-info>
        <po-info class="po-md-6"
          p-label="Fax"
          [p-value]="dadosCabec.cForFax"
          p-label-size="3"
          p-orientation="horizontal">
        </po-info>
      </div>

      <po-divider class="po-md-12 po-mt-1" p-label="DADOS DO PRODUTO/SERVIÇO"></po-divider>
      <po-table class="po-md-12"
        p-striped="true"
        p-hide-columns-manager="true"
        [p-columns]="tabelaProdutosColumns"
        [p-items]="tabelaProdutosItens">
      </po-table>

      <po-divider class="po-md-12 po-mt-1" p-label="CÁLCULO DO IMPOSTO"></po-divider>
      <div class="po-md-12">
        <po-info class="po-md-2"
          p-label="Base. Calc. ICMS"
          [p-value]="dadosCabec.nBaseCalcICMS">
        </po-info>
        <po-info class="po-md-2"
          p-label="Valor ICMS"
          [p-value]="dadosCabec.nValorICMS">
        </po-info>
        <po-info class="po-md-2"
          p-label="Base Calc. ICMS Subst."
          [p-value]="dadosCabec.nCalcSubICMS">
        </po-info>
        <po-info class="po-md-2"
          p-label="Valor ICMS Subst"
          [p-value]="dadosCabec.nValorSubICMS">
        </po-info>
        <po-info class="po-md-2"
          p-label="Valor Total Produtos"
          [p-value]="dadosCabec.nVlrTotalProd">
        </po-info>
      </div>

      <po-divider class="po-md-12 po-mt-1" p-label="TOTAIS"></po-divider>
      <div class="po-md-12">
        <po-info class="po-md-2"
          p-label="Valor Frete"
          [p-value]="dadosCabec.nValorFrete">
        </po-info>
        <po-info class="po-md-2"
          p-label="Valor Seguro"
          [p-value]="dadosCabec.nValorSeguro">
        </po-info>
        <po-info class="po-md-2"
          p-label="Desconto"
          [p-value]="dadosCabec.nDesconto">
        </po-info>
        <po-info class="po-md-2"
          p-label="Outras Desp. Acess."
          [p-value]="dadosCabec.nOutrasDesp">
        </po-info>
        <po-info class="po-md-2"
          p-label="Valor IPI"
          [p-value]="dadosCabec.nValorIPI">
        </po-info>
        <po-info class="po-md-2"
          p-label="Valor Total Pedido"
          [p-value]="dadosCabec.nVlrTotalPed">
        </po-info>
      </div>

      <po-divider class="po-md-12 po-mt-1"></po-divider>
      <div class="po-md-12">
        <p style="font-weight: bold; font-size: 15px; font-family: sans-serif; margin-left: 8px; color: #515162;">OBSERVAÇÕES:</p>
      </div>
      @if(dadosCabec.cObserv1.length > 0){
        <div class="po-md-12">
          <p style="font-size: 15px; font-family: sans-serif; margin-left: 8px; color: #1D1D30;">{{dadosCabec.cObserv1}}</p><br>
        </div>
      }
      <div class="po-md-12">
        <p style="font-size: 15px; font-family: sans-serif; margin-left: 8px; color: #1D1D30;">{{dadosCabec.cObserv2}}</p><br>
      </div>
      <div class="po-md-12">
        <p style="font-weight: bold; font-size: 15px; font-family: sans-serif; margin-left: 8px; color: #515162;">CÓDIGO DE CONDUTA E ÉTICA:</p>
        <p style="font-size: 15px; font-family: sans-serif; margin-left: 8px; color: #1D1D30;">A VENDEDORA (Fornecedor) se compromete a adotar uma conduta ética e justa nas
          relações de negócio aqui pactuadas, respeitando as diretrizes estabelecidas no Código de Conduta
          e Ética para Parceiros de Negócios da SOLIDA Brasil, disponível no endereço eletrônico
          <b><font color="green">www.solidabrasil.com.br</font></b>, o qual declara ter pleno conhecimento.
          <br>Caso observe algum comportamento que viole as condutas defendidas pela SOLIDA Brasil,
          poderá apresentar uma denúncia nos seguintes canais:
        </p><br>
        <p style="font-size: 15px; font-family: sans-serif; margin-left: 8px; color: #1D1D30;">1 - Via Internet: <b><font color="green">www.globalforestpartners.ethicspoint.com</font></b>;</p>
        <p style="font-size: 15px; font-family: sans-serif; margin-left: 8px; color: #1D1D30;">2 - Via Telefone: 0800-892-0698.</p>
      </div>
    </po-container>
  }
</po-page-default>
